export interface CurrencyConversionData {
  AmountColumn: string;
  SourceCurrencyColumn: string;
  DateColumn: string;
  DestinationCurrency: string | null;
}

export function GetDefaultCurrencyConversionData(): CurrencyConversionData {
  return {
    AmountColumn: '',
    SourceCurrencyColumn: '',
    DateColumn: '',
    DestinationCurrency: null
  };
}

export function ResetCurrencyConversionData(data: CurrencyConversionData) {
  data.AmountColumn = '';
  data.SourceCurrencyColumn = '';
  data.DateColumn = '';
  data.DestinationCurrency = null;
}
